import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
/*
Service simpliste destiné à gérer l'état affiché ou masqué du "spinner", indiquant
qu'une requête est en cours. Cet état est consommé par AppComponent (dont le template
contient le spinner), et est modifié par l'intercepteur HttpConfigInterceptor.
 */
@Injectable()
export class SpinnerService {
    /**
    * Cette variable permet de savoir combien de requêtes sont en cours d’exécution avec l’url utilisée
    * Pour les asyncValidators, le nombre d’appel à l’observable pour une même url peut être important
    * (même si la requête n’est pas vraiment envoyée, donc pas de retour après l’incrément …)
    *  et la décrémentation n’avait plus lieu.
    * Avec cette méthode, on peut gérer ce cas
    */
    private chargementEnCours: string[] = [];

    /**
     * Permet de supprimer le spinner passé un certain Timeout
     */
    private timeout: number = 15000;
    private obs: Observable<any> = of({}).pipe(delay(this.timeout));
    private sub: Subscription;
    private hiddenBS$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    public hideSpinner(url: string): void {
        /* On ne cache le spinner uniquement si plus aucune requête en cours */
        this.chargementEnCours = this.chargementEnCours.filter((entree) => (entree !== url));
        if (this.chargementEnCours.length === 0) {
            this.cacherSpinner(true);
        }
    }

    public showSpinner(url: string): void {
        /* On incrémente le compteur de requêtes en cours */
        this.chargementEnCours.push(url);
        this.cacherSpinner(false);
        if (this.sub) {
            this.sub.unsubscribe();
        }
        this.sub = this.obs.subscribe(() => {
            // Si la requête est encore en cours au bout d’un certain temps,
            // on informe l’utilisateur de l’erreur et on cache le spinner
            if (this.chargementEnCours/*.filter((entree) => (entree === url))*/.length !== 0) {
                this.cacherSpinner(true);
                console.error('Problème lors de l’appel à l’URL', url);
                alert(`Un problème est survenu lors de l’appel au serveur Java. Merci de contacter l’équipe informatique.

Dernière requête exécutée :
\t ${url}
${this.chargementEnCours.length} requête en cours :
\t ${this.chargementEnCours}

Enregistrez localement votre saisie au cas où.`);
            }
        });
    }
    public get hidden$(): Observable<boolean> {
        return this.hiddenBS$.asObservable();
    }
    /**
     * Permet de gérer l’état du spinner
     * Le setTimeOut permet de passer en asynchrone et ne pas avoir le message d’erreur ExpressionChangedAfterItHasBeenCheckedError
     * @param bool cache ou non le spinner
     */
    private cacherSpinner(bool: boolean): void {
        setTimeout(() => {
            this.hiddenBS$.next(bool);
        }, 0);
    }
}
